import { ORDER_TRACKING } from '@constants/index'
import moment = require('moment')
import Link from 'next/link'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MdKeyboardBackspace } from 'react-icons/md'
export const formatDate = (date: string, time: string) => {
  if (date && time) {
    const formattedDate = moment(`${date}T${time}`).format(
      'dddd, MMMM Do, YYYY - h:mm A',
    )
    return formattedDate
  }
  return ''
}
const ShippingTrackingHistory = ({
  tracking_info,
  showShipping,
  selectedIndex,
}: OrderTrackingInfo) => {
  const [selected, setSelected] = useState(0)
  const { t: translate } = useTranslation(['trackorder'])
  if (!tracking_info || !Object.keys(tracking_info).length) return null
  let {
    carrier,
    deliverydate,
    progressdetail,
    weight,
    tracking,
    deliverytime,
    message,
  } = Object.values(tracking_info)[selectedIndex]?.track_data

  let isUpsFreight = false
  if (progressdetail) {
    let newProgressDetail = progressdetail.find(
      (detail: { activity: string }) => detail.activity === 'Origin Scan',
    )
    isUpsFreight = newProgressDetail ? false : true
  }

  return (
    <>
      <div
        className="flex w-full"
        id="headlessui-radiogroup-:rb:"
        role="radiogroup"
      >
        {!message &&
          carrier !== ORDER_TRACKING.YRC &&
          carrier !== ORDER_TRACKING.HOLLAND && (
            <div className="w-full ">
              <div className="flex justify-between items-center mb-2 lg:mb-5">
                <h3 className="font-bold text-[20px] lg:text-[40px] font-sofia   ">
                  {translate('text-shipment-history', { cn: 'trackorder' })}
                </h3>
                <Link
                  href="javacript:void(0)"
                  onClick={showShipping}
                  className={
                    'pt-2 text-sm font-semibold lg:text-base font-sofia flex items-center gap-1'
                  }
                >
                  <MdKeyboardBackspace className="text-2xl" />
                  {translate('back', { cn: 'trackorder' })}
                </Link>
              </div>
              <div className="overflow-x-auto shadow-trackorderBox  rounded-tl-lg rounded-tr-lg">
                <table className="min-w-full">
                  <thead>
                    <tr className="bg-brand-darkblue  text-white">
                      <th className="py-2 px-4 text-left w-1/2 sm:w-1/4">
                        {translate('date-time', { cn: 'trackorder' })}
                      </th>
                      <th className="py-2 px-4 text-left  w-1/2 ">
                        {' '}
                        {translate('status', { cn: 'trackorder' })}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {progressdetail &&
                      progressdetail.length > 0 &&
                      progressdetail.map((item, index) => {
                        let {
                          activity,
                          deliverylocation,
                          deliverydate,
                          deliverytime,
                        } = item

                        const isDefaultCondition =
                          activity === ORDER_TRACKING.ORDER_PROCESSED ||
                          activity === ORDER_TRACKING.ORIGIN_SCAN ||
                          activity === ORDER_TRACKING.OUT_FOR_DELIVERY ||
                          activity.includes(ORDER_TRACKING.DELIVERED)

                        activity = isUpsFreight
                          ? activity
                          : activity === ORDER_TRACKING.ORIGIN_SCAN
                          ? ORDER_TRACKING.SHIPPED
                          : !isDefaultCondition
                          ? ORDER_TRACKING.IN_TRANSIT
                          : activity

                        return (
                          <tr key={index}>
                            <td className="py-3 px-4 border-b text-sm lg:text-base">
                              {formatDate(deliverydate, deliverytime)}
                            </td>
                            <td className="py-3 px-4 border-b font-semibold ">
                              <div
                                className={`text-sm lg:text-base  font-semibold ${
                                  activity === ORDER_TRACKING.IN_TRANSIT
                                    ? 'text-yellow-100'
                                    : 'text-brand-green'
                                }`}
                              >
                                {activity}
                              </div>
                              {deliverylocation && (
                                <div className="text-sm lg:text-base  text-brand-muted">
                                  {deliverylocation}
                                </div>
                              )}
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
      </div>
    </>
  )
}
export default ShippingTrackingHistory
